export default {
      id: "oc-navbar-user-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-navbar-user",
      toString: function () {
        return this.url;
      }
    }